import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    backgroundColor: theme.palette.background.default,
  },
  outerContainer: {
    padding: '10px',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  title: {
    paddingBottom: '10px',
  },
  tableButton: {
    color: theme.palette.primary.main,
    fontSize: '0.8rem',
  },
  status: {
    color: theme.palette.text.primary,
    width: '155px',
  },
  link: {
    cursor: 'pointer',
  },
  iconButton: {
    color: theme.palette.text.primary,
  },
  iconButtonText: {
    fontSize: '0.8rem',
  },
  iconButtonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
